import { useState, useEffect } from 'react';
import { Link } from 'react-router';

import { useAPIContext, api } from '../../../api/context';
import toast from '../../../utils/toast';
import currency from '../../../utils/currency';
import Base from '../../Base';
import styles from './Wallet.module.scss';

const Wallet = () => {

  const { token } = useAPIContext();

  const [ loading, setLoading ] = useState(true);
  const [ data, setData ] = useState();

  useEffect(() => {

    api(token).v1.profile.query()
      .then(res => {
        setLoading(false);
        setData(res.body.data);
      })
      .catch(err => {
        setLoading(false);
        toast.show(toast.KIND.WARNING, err);
      });

  }, [token]);

  return (
    <Base title='Wallet'>
      <div className={styles.root}>
        {
          loading && (
            <p>Loading...</p>
          )
        }

        {
          data && (
            <div>
              <h3>Chimeable Cash Rewards</h3>

              <p className={styles.item}>
                <span>Current Balance</span>
                <span>
                  {currency.repr(data.wallet.main.currency)}
                  {' '}
                  {data.wallet.main.balance}
                </span>
              </p>

              <p className={styles.item}>
                <span>Lifetime Earnings</span>
                <span>
                  {currency.repr(data.wallet.main.currency)}
                  {' '}
                  {data.wallet.main.settled}
                </span>
              </p>

              <p className={styles.item}>
                <span>PayPal Email</span>
                <span>{data.paypal.email || 'N/A'}</span>
                <Link to={`?dialog=paypal&target=${encodeURIComponent('?dialog=wallet')}`}>
                  Change
                </Link>
              </p>

              <p className={styles.note}>
                Payments will be deposited into your PayPal account
                once your balance exceeds $10 (subject to change).
                
                For more details, click <Link to='/terms-and-conditions'>here</Link>. 
              </p>
            </div>
          )
        }
      </div>
    </Base>
  );
};

export default Wallet;